<template>
  <footer class="site-footer">
    <div class="footer-content">
      <!-- Header del Footer: Links de servicios -->
      <div class="footer-header">
        <nav class="footer-nav">
          <router-link to="/flights" @click="scrollToTop">Vuelos</router-link>
          <span class="separator">|</span>
          <router-link to="/hotels" @click="scrollToTop">Hoteles</router-link>
          <span class="separator">|</span>
          <router-link to="/cars" @click="scrollToTop">Autos</router-link>
          <span class="separator">|</span>
          <router-link to="/lounges" @click="scrollToTop"
            >Salas vip</router-link
          >
          <span class="separator">|</span>
          <a href="#">Espectáculos</a>
          <span class="separator">|</span>
          <a href="#">Parques Temáticos</a>
          <span class="separator">|</span>
          <router-link to="/assists" @click="scrollToTop"
            >Asistencias</router-link
          >
        </nav>
      </div>

      <!-- Body del Footer: Info y PlaceToPay -->
      <div class="footer-body">
        <div class="footer-info-links">
          <a
            href="/documents/Terminos_Condiciones_Banco_Caribe.pdf"
            target="_blank"
            >Términos y Condiciones</a
          >
          <span class="separator">|</span>
          <a
            href="/documents/Preguntas_Frecuentes_Banco_Caribe.pdf"
            target="_blank"
            >Preguntas Frecuentes</a
          >
          <span class="separator">|</span>
          <div class="payment-logo">
            <img
              src="@/assets/images/footer-platetopay.svg"
              alt="Logo Place to Pay"
            />
          </div>
        </div>
      </div>

      <!-- Footer del Footer: Logo a la izquierda -->
      <div class="footer-bottom">
        <div class="footer-logo">
          <img
            src="@/assets/images/logo-banco-caribe.svg"
            alt="Caribe Rewards Logo"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComp",
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.site-footer {
  background-color: #ebebec;
  color: var(--color-acento-secundario);
  width: 100%;
  display: flex;
  justify-content: center;
}

.footer-content {
  max-width: 1200px;
  width: 100%;
  padding: 30px 5%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Header y Body centrados */
.footer-header,
.footer-body {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.footer-header {
  border-bottom: 1px solid #999; /* Línea oscura */
  padding-bottom: 20px;
  width: 100%; /* Ocupa el ancho del contenedor */
  margin: 0 auto; /* Centrado horizontal */
}

.footer-nav,
.footer-info-links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
}

.footer-nav a,
.footer-info-links a {
  text-decoration: none;
  color: var(--color-acento-secundario);
  font-weight: 600;
  font-size: 0.95rem;
  transition: color 0.2s;
}

.footer-nav a:hover,
.footer-info-links a:hover {
  color: var(--color-acento-primario);
}

.separator {
  color: white;
  font-size: 1.2rem;
  font-weight: 300;
  user-select: none;
}

.payment-logo {
  display: flex;
  align-items: center;
}

.payment-logo img {
  height: 30px;
  object-fit: contain;
}

/* Footer bottom alineado a la izquierda */
.footer-bottom {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}

.footer-logo img {
  height: 30px;
  object-fit: contain;
  max-width: 100%;
}

@media (max-width: 1024px) {
  .footer-content {
    padding: 20px;
  }
  .footer-nav,
  .footer-info-links {
    gap: 10px;
  }
  .separator {
    display: none; /* Ocultamos separadores en móvil para mejor flujo */
  }
  .footer-nav,
  .footer-info-links {
    flex-direction: column;
  }
  .footer-bottom {
    justify-content: center; /* Centramos el logo en móvil */
  }
}
</style>
